<template>
	<div class="con">
		<uploadimg @upload="upload01" ref="upload1" style="display: none;"></uploadimg>
		<div class="title">
			<div class="titles">申请公开参观环境</div>
		</div>
		<div style="width: 100%;display: flex;">
			<div class="scroll" style="width: 43%;background: #fff;margin-top: 20px;margin-bottom: 20px;overflow-y: scroll;" :style="{height:height}">
				<div style="width: 92%;margin: 0 auto;height: 100%;">
					<iframe
					  width="100%"
					  height="100%" 
					  scrolling='no' 
					  src="https://www.metabiz.com.cn/html/gongzhongcanguan.html" 
					  frameborder="0">
					</iframe>
				</div>
			</div>
			<a href=""></a>
			<div style="width: 55%;margin-left: auto;cursor: pointer;">
				<div class="nav" ref="element">
					<div class="navs" :class="[dataForm.types==2?'navselect':'']" @click="quehuanzuzhi(2)">组织</div>
					<div class="navs" :class="[dataForm.types==1?'navselect':'']" @click="quehuanzuzhi(1)">个人</div>
				</div>
				<div class="cons" >
					<div class="cons02" ref="element01">
						<el-form :model="dataForm" ref="dataForm" :inline="false" :rules="rules">
							<el-form-item label="环境名称" prop="title">
								<el-input placeholder="请输入" v-model="dataForm.title"></el-input>
							</el-form-item>
							<el-form-item label="环境图标" class="buxu"></el-form-item>
							<div style="display: flex;position: relative;align-items: flex-end;">
								<div class="imgurl">
									<el-image style="width: 100%;height: 100%;border-radius: 10px;"
									v-if="dataForm.icon"
									 :src="dataForm.icon"
									  :preview-src-list="[dataForm.icon]"></el-image>
								</div>
								<div class="shangchuan">
									<el-button type="text" @click="dianjis(1)">点击上传</el-button>
						<!-- 			<span style="font-size: 14px;">(320*320)</span> -->
								</div>
							</div>
							<el-form-item style="margin-top: 22px;" label="申请者名称" v-if="dataForm.types==2" :prop="dataForm.types==2?'sname':''">
								<el-input placeholder="请输入" v-model="dataForm.sname"></el-input>
							</el-form-item>
							<el-form-item label="申请者logo"  v-if="dataForm.types==2" class="buxu"></el-form-item>
							<div  v-if="dataForm.types==2" style="display: flex;position: relative;align-items: flex-end;">
								<div class="imgurl" style="width: 60px;height: 60px;">
									<el-image style="width: 100%;height: 100%;border-radius: 10px;"
									v-if="dataForm.slogo"
									 :src="dataForm.slogo"
									  :preview-src-list="[dataForm.slogo]"></el-image>
								</div>
								<div class="shangchuan">
									<el-button type="text" @click="dianjis(2)">点击上传</el-button>
									<!-- <div style="font-size: 14px;">说明：n*64，n>64并且n<=160，PNG等图片格式（支持透明底色）</div> -->
								</div>
							</div>
							<!--联系人的信息-->
							<el-row style="display: flex;margin-top: 22px;">
								<el-col :span="11">
									<el-form-item label="联系人姓名" class="buxu">
										<el-input placeholder="请输入" v-model="dataForm.name"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="11" style="margin-left: auto;">
									<el-form-item label="联系人性别" class="buxu">
										<el-select style="width: 100%;" v-model="dataForm.sex" placeholder="请选择">
										    <el-option
										      v-for="item in [{value:'男'},{value:'女'}]"
										      :key="item.value"
										      :label="item.value"
										      :value="item.value">
										    </el-option>
										  </el-select>
									</el-form-item>
								</el-col>
							</el-row>
							
							<el-row style="display: flex;margin-top: 22px;">
								<el-col :span="11">
									<el-form-item label="联系人电话" prop="phone">
										<el-input type="number" placeholder="请输入" v-model="dataForm.phone"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="11" style="margin-left: auto;">
									<el-form-item label="存续时长(1-12)">
										<el-input placeholder="请输入" v-model="dataForm.cunxu" type="number">
											 <template slot="append">月</template>
										</el-input>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row style="display: flex;margin-top: 22px;">
								<el-col :span="11">
									<el-form-item label="数据库空间(1-10)">
										<el-input placeholder="请输入" v-model="dataForm.mysql" type="number">
											 <template slot="append">100GB</template>
										</el-input>
										<div style="color: red;font-size: 16px;font-weight: bold;margin-top: 20px;">
											请关注“领驭融合”服务号
										</div>
										<div style="color: red;font-size: 16px;font-weight: bold;">
											以及时获取环境信息
										</div>
									</el-form-item>
								</el-col>
								<el-col :span="11" style="margin-left: auto;">
									<img src="@/assets/weixin.png" style="width: 200px;height: 200px;" alt="">
								</el-col>
							</el-row>
							<!--联系人的信息-->
						</el-form>
					</div>
				</div>
			</div>
		</div>
		
		<div style="width: 100%;display: flex;align-items: center;justify-content: center;padding-bottom: 30px;">
			<el-checkbox v-model="checked">我已仔细阅读并接受上述SasS最终用户协议</el-checkbox>
			<el-button style="width: 100px;border-radius: 40px;margin-left: 20px;" type="primary" @click="save">提交</el-button>
		</div>
	</div>
</template>

<script>
	import uploadimg from "@/common/ImgUpload.vue"
	import { user_save_huanjing } from "@/api/huanjing"
	import { getToken } from '@/utils/auth'
    import { isMobile } from "@/utils/rules"
	export default {
		components:{
			uploadimg
		},
		name:"hj01",
		data(){
			return{
				checked:false,
				dataForm:{
					type:1,
					types:2,//1个人 2组织
					title:'',//环境名称
					icon:'',//环境图标
					sname:'',//申请者名称 types为2时必填
					slogo:'',//申请者logo 85*85
					name:'',//联系人姓名
					sex:'',//联系人性别
					phone:'',//联系人电话
					cunxu:'',//存续时长 单位月 1-12
				    mysql:'',//数据库空间 单位100GB 1-10
				},
				rules:{
					title:[{ required: true, message: '不能为空', trigger: 'blur' }],
					sname:[{ required: true, message: '不能为空', trigger: 'blur' }],
					phone:[{ required: true, message: '不能为空', trigger: 'blur' }],
					cunxu:[{ required: true, message: '不能为空', trigger: 'blur' }],
					mysql:[{ required: true, message: '不能为空', trigger: 'blur' }],
				},
				imgtype:1,//1环境图标 2申请者logo
				height:'0px',
			}
		},
		created(){
			
		},
		watch:{
			//判断存续时长
			"dataForm.cunxu"(e){
				if(e<1){
					this.$message.error("存续时长最小1个月");
					this.dataForm.cunxu = 1
				}
				if(e>12){
					this.$message.error("存续时长最大12个月");
					this.dataForm.cunxu = 12
				}
			},
			///判断数据库空间
			"dataForm.mysql"(e){
				if(e<1){
					this.$message.error("数据库空间最小1");
					this.dataForm.mysql = 1
				}
				if(e>10){
					this.$message.error("数据库空间最大10");
					this.dataForm.mysql = 10
				}
			},
		},
		mounted(){
			this.height = (this.$refs.element.offsetHeight + this.$refs.element01.offsetHeight) + 'px'
		},
		methods:{
			quehuanzuzhi(types){
				this.dataForm.types = types
				this.height = (this.$refs.element.offsetHeight + this.$refs.element01.offsetHeight) + 'px'
			},
			async save(){
				let that = this;
				if(!that.checked){
					this.$message.error("请勾选协议");
					return;
				}
				that.$refs['dataForm'].validate((valid) => {
					if (valid) {
						console.log("请求的参数",that.dataForm);
						//如果是个人，则需要删除相对应的参数
						if(that.dataForm.types==1){
							delete that.dataForm.sname
							delete that.dataForm.slogo
						}
						if(!isMobile(that.dataForm.phone)){
							this.$message.error("手机号格式不正确");
							return;
						}
						const loading = this.$loading({
						    lock: true,
						    text: '提交中',
						    spinner: 'el-icon-loading',
						    background: 'rgba(0, 0, 0, 0.7)'
						  });
						user_save_huanjing(that.dataForm).then(res=>{
							loading.close();
							that.$message.success("提交成功");
							//此时携带orderid跳转到订单页面
							console.log(res.data.orderid);
							this.$router.push({
								path:"/neirong",
								query:{
									orderid:res.data.orderid
								}
							})
						}).catch(()=>{
							loading.close();
						})
					}else{
						
					}
				})
			},
			dianjis(type){
				this.imgtype = type
				//环境图标
				this.$refs.upload1.handleUpload();
			},
			upload01(file){
				console.log(file,this.imgtype);
				let that = this;
				if(that.imgtype==1){
					that.dataForm["icon"] = file
				}
				if(this.imgtype==2){
					that.dataForm["slogo"] = file
				}	
			},
		},
	}
</script>

<style lang="scss" scoped>
	.shangchuan{
		margin-left: 10px;
	}
	/deep/ .buxu{
		margin-bottom: 0px!important;
	}
	/deep/ .el-input__inner{
		background: #f6f8f9!important;
	}
	/deep/ .el-form-item__label:before {
		content: '*';
		color: #F56C6C;
		margin-right: 4px;
		display: none;
	}
	/deep/ .el-form-item__label:after {
		content: '*';
		color: #F56C6C;
		margin-left: 4px;
	}
	/deep/ .buxu .el-form-item__label:after {
		content: '*';
		color: #F56C6C;
		margin-right: 4px;
		display: none;
	}
	.imgurl{
		width: 280px;
		height: 280px;
		border: 1px solid #dfdfdf;
		border-radius: 10px;
		img{
			width: 100%;
			height: 100%;
			border-radius: 10px;
		}
	}
	.con{
		.cons{
			width: 100%;
			display: flex;
			padding-top: 30px;
			padding-bottom: 30px;
			.cons01{
				width: 30%;
				.co01{
					color: #333;
					font-size: 18px;
				}
				.co02{
					width: 30px;
					height: 2px;
					background: #00a9f2;
					margin-top: 5px;
				}
				.co03{
					color: #666;
					font-size: 14px;
					margin-top: 15px;
				}
			}
			.cons02{
				width: 100%;
			}
		}
		.navselect{
			background: #00a9f2;
			color: #fff!important;
		}
		.nav{
			width: 100%;
			height: 80px;
			border-bottom: 1px solid #dfdfdf;
			display: flex;
			align-items: center;
			cursor: pointer;
			.navs{
				width: 100px;
				height: 40px;
				border-radius: 30px;
				display: flex;
				align-items: center;
				justify-content: center;
				color: #333;
				font-size: 16px;
			}
		}
		.title{
			width: 100%;
			height: 50px;
			border-bottom: 1px solid #dfdfdf;
			position: relative;
			.titles{
				height: 30px;
				color: #333;
				font-size: 26px;
				position: absolute;
				bottom: 20px;
				right: 30px;
			}
		}
		width: 1200px;
		margin: 0 auto;
	}
</style>


// WEBPACK FOOTER //
// src/views/huanjing/hj01/index.vue